export default __webpack_public_path__ + "static/media/chefspicKh264.da29b002.mp4";